import { getDataMapper, mapField, formatISO } from "@/shared";

export const mapRentTimeToServer = getDataMapper({
    time_start: mapField("timeStart", formatISO),
    time_end: mapField("timeEnd", formatISO),
});
